import * as React from 'react';
import {
	buildWorkOrderCheckComparisonRows,
	getWorkOrderCheckOutcome,
} from '../../utils/InvoiceUtils';
import { WorkOrderCheckAlert } from './WorkOrderCheckAlert';
import { WorkOrderCheckComparisonTable } from './WorkOrderCheckComparisonTable';
import { getWorkOrderCheckSeverity } from './workOrderCheckSeverity';

interface WorkOrderCheckWarningProps {
	workOrderCheck: any;
	parsedData: any;
	workOrder: any;
}

/**
 * The same evidence kept on the invoice form after the uploader chose to continue anyway, so the
 * reason stays in front of whoever reviews the invoice rather than living only in a modal that has
 * already been dismissed. Same alert and table as the modal, without the card or the buttons.
 */
export const WorkOrderCheckWarning: React.FC<WorkOrderCheckWarningProps> = ({
	workOrderCheck,
	parsedData,
	workOrder,
}) => {
	const rows = buildWorkOrderCheckComparisonRows(workOrderCheck, parsedData, workOrder);
	const severity = getWorkOrderCheckSeverity(getWorkOrderCheckOutcome(workOrderCheck));

	return (
		<div className="flex w-full flex-col gap-y-m">
			<WorkOrderCheckAlert
				title={severity.title}
				subtitle={severity.subtitle}
				iconClassName={severity.iconClassName}
			/>
			<WorkOrderCheckComparisonTable
				rows={rows}
				invoiceCellClassName={severity.invoiceCellClassName}
			/>
		</div>
	);
};

export default WorkOrderCheckWarning;
